import React, { lazy } from "react";
import NavigationTeam from "@brightinsight/bi-web-core/assets/NavigationTeam.svg";

export class RouteConstants {
  static TeamContainer = lazy(
    () => import(/* webpackChunkName: "Team" */ "../layout/TeamContainer")
  );

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: "/teams", // URL path for the patients list
      component: React.createElement(RouteConstants.TeamContainer), // Component to render for this route
      actionName: "view", // Action name associated with this route
      displayName: "Teams", // Display name for the route
      isMenu: true, // Indicates if this route should be shown in the menu
      icon: NavigationTeam,
    },
  ];
}
